import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AiWorkflowPage, QueryAiTranslationWorkflowsArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryAiTranslationWorkflowsArgs;
type TData = AiWorkflowPage;

const MOCK: TVariables = { id: '', query: '' };

export const useAgentsList = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query aiTranslationWorkflows(
      $id: ID
      $query: String
      $page: Int
      $sortAttribute: AiTranslationWorkflowSortAttributeEnum
      $sortOrder: SortOrderEnum
      $perPage: Int
      $skipPagination: Boolean
      $active: Boolean
    ) {
      aiTranslationWorkflows(
        id: $id
        query: $query
        page: $page
        perPage: $perPage
        skipPagination: $skipPagination
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        active: $active
      ) {
        hasNextPage
        hasPreviousPage
        nodesCount
        pagesCount
        nodes {
          active
          createdAt
          id
          name
          postediting
          sourceLanguageCode
          targetLanguageCodes
          steps {
            id
            subSteps {
              id
              type
              content {
                type
                value
              }
              sourceId
              sourceType
            }
            type
          }
          glossary {
            id
            name
          }
          styleGuide {
            referenceId
            name
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useAgentsList', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
